/**
 * Cleans text that will be embroidered or printed (B2C text logos and portal
 * personalisation) as the customer types, so a disallowed character never
 * appears in the box. Mirrors App\Support\EmbroideryText, which re-applies the
 * rule on the server and is the authority: keep the two in step.
 */

// Characters phones and Macs substitute automatically, mapped back to plain ones
const REPLACEMENTS = {
    "‘": "'", "’": "'", "‚": "'", "′": "'",
    "“": '"', "”": '"', "„": '"', "″": '"',
    "–": "-", "—": "-", "‐": "-", "‑": "-", "−": "-",
    " ": " ",
};
const REPLACEABLE = /[‘’‚′“”„″–—‐‑− ]/g;

// Anything other than letters, digits, space and !"#$%&'()*+,-./
const DISALLOWED = /[^A-Za-z0-9 !"#$%&'()*+,\-./]/g;

/**
 * Unlike the PHP version this does not trim, or a space typed between
 * words would vanish before the next word is typed
 */
export function sanitiseEmbroideryText(text)
{
    return text
        .replace(REPLACEABLE, character => REPLACEMENTS[character])
        .normalize("NFD")           // é becomes e + ´
        .replace(/\p{M}/gu, "")     // drop the accents
        .replace(DISALLOWED, "");
}

function clean(input)
{
    const original = input.value;
    const cleaned = sanitiseEmbroideryText(original);

    if (cleaned === original)
    {
        return;
    }

    // Keep the cursor where it was, less anything removed before it
    const cursor = sanitiseEmbroideryText(original.slice(0, input.selectionStart ?? original.length)).length;
    input.value = cleaned;
    input.setSelectionRange(cursor, cursor);
}

/**
 * Clean every input inside root that matches selector, including inputs added
 * later (portal assignment rows are cloned from a template). Listening in the
 * capture phase means this runs before any listener on the input itself.
 */
export function sanitiseEmbroideryTextWithin(root, selector)
{
    root.addEventListener("input", (e) => {
        // Mid-way through typing an accent (Option+E then E on a Mac) the box
        // holds an unfinished character; cleaning it then breaks the typing,
        // so wait for compositionend
        if (e.target.matches(selector) && !e.isComposing)
        {
            clean(e.target);
        }
    }, true);
    root.addEventListener("compositionend", (e) => {
        if (e.target.matches(selector))
        {
            clean(e.target);
        }
    }, true);
}
